import React from 'react';
import { connect } from 'react-redux';
import T from 'prop-types';
import * as selectors from 'selectors';
import * as Modules from 'components/modules';
import { backgroundImageType } from 'types';
import styles from './flipperSection.css';
import Flipper from './Flipper';
import * as s from './styled';

const VisibleText = ({
  narrowText,
  text,
  titleColor,
  subtitleColor,
  descriptionColor,
  reversed,
}) => {
  const reversedNumber = +reversed;

  if (narrowText) {
    return (
      <s.RegularTextContainer reversed={reversedNumber}>
        <Modules.TextBlock1
          {...text}
          colors={{
            title: titleColor,
            subtitle: subtitleColor,
            description: descriptionColor,
          }}
        />
      </s.RegularTextContainer>
    );
  }
  return (
    <s.TextContainer reversed={reversedNumber}>
      <s.H2 className="flipperText" color={titleColor}>
        {text.title}
      </s.H2>

      <s.H3 className="flipperText" color={subtitleColor}>
        {text.subtitle}
      </s.H3>
    </s.TextContainer>
  );
};

VisibleText.defaultProps = {
  titleColor: null,
  subtitleColor: null,
  descriptionColor: null,
};
VisibleText.propTypes = {
  narrowText: T.number.isRequired,
  text: T.shape({
    title: T.string,
    subtitle: T.string.isRequired,
    // description: T.oneOfType([T.string, T.arrayOf(T.string)]).isRequired,
  }).isRequired,
  titleColor: T.string,
  subtitleColor: T.string,
  descriptionColor: T.string,
  reversed: T.oneOfType([T.string, T.number]).isRequired,
};

class FlipperSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleText: props.data[0].text,
      slideIndex: 0,
      intoView: false,
    };

    if (props.data.length > 1) {
      if (props.data[1].text.title) {
        this.dotsPosition = 'flipper';
      } else {
        this.dotsPosition = 'flipper';
      }
    } else this.dotsPosition = false;

    this.slideChanged = (slideIndex) => {
      this.setState({
        visibleText: this.checkTextPresence(slideIndex)
          ? this.props.data[slideIndex].text
          : this.props.data[0].text,
        slideIndex,
      });
    };
  }

  componentWillReceiveProps(nextProps) {
    const intoView = nextProps.scrollPosition === this.props.scrollIndex;

    if (intoView) {
      this.setState({ intoView: true });
    } else if (this.state.intoView) {
      this.setState(() => ({ intoView: false }));
    }
  }

  checkTextPresence = slideIndex =>
    this.props.data[slideIndex].text.title ||
    this.props.data[slideIndex].text.subtitle ||
    this.props.data[slideIndex].text.description[0];

  render() {
    const {
      id,
      colors,
      data,
      reversed,
      height,
      narrowText,
      textAlign,
      textHorizAlign,
      backgroundImage: {
        mobile: backgroundImageMobile,
        desktop: backgroundImageDesktop,
      },
    } = this.props;
    const { visibleText, intoView } = this.state;
    const reversedNumber = +reversed;
    const narrowTextNumber = +narrowText;
    const isBackgroundImagePresent = !!(
      backgroundImageMobile.src || backgroundImageDesktop.src
    );
    return (
      <s.Section
        id={id}
        backgroundColor={isBackgroundImagePresent && colors.background}
        reversed={reversedNumber}
        height={height}
      >
        {isBackgroundImagePresent && (
          <s.BackgroundOverlay
            backgroundColor={colors.background}
            backgroundImageDesktop={backgroundImageDesktop}
            backgroundImageMobile={backgroundImageMobile}
          />
        )}
        <s.FlipperWrapper
          backgroundColor={
            !isBackgroundImagePresent && colors.flipperBackground
          }
        >
          {!isBackgroundImagePresent && <s.Overlay  className={styles.overlay} />}
          <Flipper
            dots={this.dotsPosition === 'flipper'}
            dotsColor={colors.dots}
            slideChanged={this.slideChanged}
            dataArray={data}
            intoView={intoView}
          />
        </s.FlipperWrapper>
        <s.TextWrapper
          textAlign={textAlign}
          textHorizAlign={textHorizAlign}
          backgroundColor={!isBackgroundImagePresent && colors.background}
        >
          <s.RegularTextContainer reversed={reversedNumber}>
            <Modules.TextBlock1 {...visibleText} colors={colors} />
          </s.RegularTextContainer>
          {this.dotsPosition === 'text' && (
            <Modules.Dots
              className={styles.dots}
              quantity={data.length}
              color={colors.dots}
              activeIndex={this.state.slideIndex}
            />
          )}
        </s.TextWrapper>
      </s.Section>
    );
  }
}

FlipperSection.defaultProps = {
  height: null,
  scrollPosition: null,
  id: null,
  backgroundImage: {
    desktop: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
    mobile: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
  },
};
FlipperSection.propTypes = {
  colors: T.shape({
    background: T.string,
    title: T.string,
    subtitle: T.string,
    description: T.string,
  }).isRequired,
  data: T.arrayOf(T.shape({
    src: T.string,
    alt: T.string,
    title: T.string,
    subtitle: T.string,
  })).isRequired,
  backgroundImage: T.shape({
    desktop: backgroundImageType,
    mobile: backgroundImageType,
  }),
  reversed: T.oneOfType([T.string, T.number]).isRequired,
  height: T.string,
  narrowText: T.string.isRequired,
  scrollPosition: T.number,
  scrollIndex: T.number.isRequired,
  textAlign: T.string.isRequired,
  textHorizAlign: T.string.isRequired,
  id: T.string,
};

const mapStateToProps = state => ({
  scrollPosition: selectors.getScrollPosition(state),
});

export default connect(mapStateToProps)(FlipperSection);



// WEBPACK FOOTER //
// ./src/components/modules/FlipperSection/FlipperSection.js